import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "../components/flexproducts";
import Header from "../headers_footer/header";

const Sunscreen = () => {

return (

<div>

<Navbar />
<Flexproducts type="sunscreen" />
<Header></Header>

</div>

);
};

export default Sunscreen;